<mat-sidenav-container class="tools-sidenav__container sidenav__container-full-page-height">
  <mat-sidenav
    #sideFilter
    position="end"
    class="tools-sidenav__drawer"
    [fixedInViewport]="true">
    <div id="filterbar">
      <filter-bar
        *ngIf="filterActive && aggregations"
        [aggregations]="aggregations"
        (filterBarClose)="sideFilter.close()"></filter-bar>
    </div>
  </mat-sidenav>

  <div class="row page-title">
    <span>{{ localizationConstants.MY_TOOLS_PAGE_TITLE | translate }}</span>
  </div>

  <!-- <section *ngIf="tools && viewType.value === 'out-for-service'" id="tools-filter" class="row center">
    <div class="col-12 col-md-8 tools-filter">
        <div class="o-grid">
            <div class="o-grid__item col-12">
                <ul class="step-timeline">
                    <li *ngFor="let status of groupedStatuses" class="step-timeline__item">
                        <div 
                            id="step-item-1" 
                            class="step-timeline__button c-clickable c-numeric" 
                            [class.active]="status.current"
                            (click)="toggleGroupedStatus(status)">
                            {{ status.toolsCount }}
                        </div>
                        <div class="step-timeline__title">{{ status.title | translate }}</div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</section> -->
  <!-- <section *ngIf="tools && viewType.value === 'onsite'" id="tools-filter" class="row center">
    <div class="container col-12 col-md-8 col-lg-6 tools-filter">
        <div class="o-grid">
            <div class="o-grid__item col-12">
                <ul class="step-timeline">
                    <li class="step-timeline__item no-line">
                        <div id="st-item-1" 
                            class="step-timeline__button c-clickable c-numeric" 
                            [class.active]="getServiceDueStatus()" 
                            (click)="toggleServiceDue()">
                            <tool-counter type="Service" (onValueEvent)="toolsDueServiceCount = $event">
                                <span *ngIf="toolsDueServiceCount">{{ toolsDueServiceCount }}</span>
                                <span *ngIf="!toolsDueServiceCount">
                                    <fa-icon class="u-color--light" [icon]="faSpinner" [spin]="true" size="sm"></fa-icon>
                                </span>          
                            </tool-counter>
                        </div>
                        <div class="step-timeline__title">{{ 'tools.dueforservice'  | translate}}</div>
                    </li>
                    <li class="step-timeline__item">
                        <div 
                            id="st-item-2"
                            class="step-timeline__button c-clickable c-numeric"
                            [class.active]="getCalibrationDueStatus()"
                            (click)="toggleCalibrationDue()">
                            <tool-counter type="Calibration" (onValueEvent)="toolsDueCalibrationCount = $event">
                                <span *ngIf="toolsDueCalibrationCount">{{ toolsDueCalibrationCount }}</span>
                                <span *ngIf="!toolsDueCalibrationCount">
                                    <fa-icon class="u-color--light" [icon]="faSpinner" [spin]="true" size="sm"></fa-icon>
                                </span>          
                            </tool-counter>
                        </div>
                        <div class="step-timeline__title">{{ 'tools.dueforcalibration'  | translate}}</div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</section> -->

  <section
    *ngIf="tools.data"
    id="tools"
    class="row">
    <div class="col-12">
      <div class="o-grid--small between">
        <div class="o-grid__item col-lg-6 col-12">
          <filter-state-chips
            [aggregations]="aggregations"
            (filterOpen)="sideFilter.open()"></filter-state-chips>
        </div>
        <div class="o-grid__item">
          <tool-export-button
            [excelExportType]="ExcelExportType.Tools"
            [toolFilter]="filter"></tool-export-button>
        </div>
        <div class="o-grid__item col-4 u-desktop end top flex">
          <div class="o-grid--small col end">
            <div class="o-grid__item col">
              <form
                #f="ngForm"
                class="c-search-filter-form"
                (ngSubmit)="onSearch()">
                <div class="c-input-group">
                  <input
                    type="text"
                    name="search"
                    id="input-search"
                    [(ngModel)]="quickSearch"
                    class="c-input c-input--alpha c-input--main"
                    [placeholder]="'tools.search' | translate" />
                  <input
                    *ngIf="!quickSearch"
                    id="tools-search"
                    type="submit"
                    class="c-button c-button--search"
                    value="Search" />
                  <button
                    *ngIf="!!quickSearch"
                    id="tools-search"
                    type="button"
                    (click)="quickSearch = null; onSearch()"
                    class="c-button c-button--search c-close-search"
                    value="Clear"></button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div class="o-grid">
        <!-- ToolsGrid -->
        <div class="o-grid__item col">
          <div class="u-scroll--horizontal flex">
            <div
              id="tool-table"
              class="tools-table table-mobile col">
              <table
                mat-table
                [dataSource]="tools"
                (matSortChange)="onSort($event)"
                *ngIf="tools.data"
                matSort
                class="c-table"
                [class.table-overflowed]="isTableOverflow">
                <ng-container
                  *ngFor="let col of getSelectHeaderColumns(); index as i"
                  [matColumnDef]="col"
                  [sticky]="i === 0 && !isScreenWidthLessThanSm">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    class="c-table-selector-grid__header">
                    <div>
                      <mat-select
                        [(ngModel)]="selectedColumns[i]"
                        (ngModelChange)="onDropDownChange()"
                        [compareWith]="compareColumnsById"
                        class="c-user-menu__select c-select c-select--lg">
                        <mat-option
                          *ngFor="let item of getColumnOptions(i)"
                          [value]="item">
                          {{ item.headerTitle | translate }}
                        </mat-option>
                      </mat-select>
                      <span *ngIf="i !== 0 && i !== selectedColumns.length">
                        <button
                          mat-icon-button
                          [disableRipple]="true"
                          (click)="removeColumn(i)"
                          class="delete-col-button">
                          <mat-icon
                            svgIcon="trash-can"
                            class="icon-size-xs"></mat-icon>
                        </button>
                      </span>
                    </div>
                  </th>
                </ng-container>

                <ng-container
                  matColumnDef="action_upper_header"
                  [stickyEnd]="!isScreenWidthLessThanSm">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    class="c-table-selector-grid__header add-column-header">
                    <button
                      (click)="addNewColumn()"
                      class="button--sm button-block add-col-button button-primary">
                      <span class="flex middle center">
                        <mat-icon svgIcon="add"></mat-icon>
                        <span class="button__label">{{
                          localizationConstants.BUTTON_ADD_COLUMN | translate
                        }}</span></span
                      >
                    </button>
                  </th>
                </ng-container>

                <ng-container
                  *ngFor="let col of selectedColumns; index as i"
                  [matColumnDef]="col.field"
                  [sticky]="i === 0 && !isScreenWidthLessThanSm">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    [disabled]="!col.sortable"
                    class="c-table__column-header">
                    {{ col.headerTitle | translate }}
                  </th>

                  <td
                    mat-cell
                    *matCellDef="let tool"
                    width="22%"
                    class="c-clickable"
                    [routerLink]="[
                      routeNameConstants.TOOLS_DETAILS_BASE,
                      tool.companyId,
                      tool.serialNumber,
                    ]">
                    <ng-container [ngSwitch]="col.filter">
                      <span *ngSwitchCase="'string'">{{ tool[col.field] }}</span>
                      <span *ngSwitchCase="'date'">{{ tool[col.field] | date }}</span>
                      <span *ngSwitchCase="'boolean'">{{ tool[col.field] ? "Yes" : "No" }}</span>
                      <span *ngSwitchCase="'eventStatus'">{{
                        getGroupedStatusLabel(tool[col.field])
                      }}</span>
                      <span *ngSwitchCase="'worktype'">{{
                        getWorktypeLabel(tool[col.field])
                      }}</span>
                      <span
                        *ngSwitchCase="'serviceDueDate'"
                        [class.c-overedue]="tool.serviceDue || tool.serviceOverdue"
                        >{{ tool[col.field] | date }}</span
                      >
                      <span
                        *ngSwitchCase="'dueDate'"
                        [class.c-overedue]="tool.calDue || tool.calOverdue"
                        >{{ tool[col.field] | date }}</span
                      >
                      <span *ngSwitchCase="'contracts'">
                        <div
                          class="c-chip u-box-clickable"
                          *ngFor="let contract of tool[col.field]"
                          [routerLink]="[
                            routeNameConstants.CONTRACTS_DETAILS_BASE,
                            companyService.selectedCompany?.name,
                            contract,
                          ]">
                          {{ contract }}
                        </div>
                      </span>
                      <span *ngSwitchDefault>
                        {{ tool[col.field] }}
                      </span>
                    </ng-container>
                  </td>
                </ng-container>

                <ng-container
                  [matColumnDef]="'action'"
                  [stickyEnd]="!isScreenWidthLessThanSm">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    class="c-table__column-header"
                    width="10%"></th>

                  <td
                    mat-cell
                    *matCellDef="let tool">
                    <span>
                      <service-request-button
                        *ngIf="toolService.canAddToRA(tool)"
                        [tool]="tool"></service-request-button>
                      <purchase-order-button
                        *ngIf="toolService.canAddToPO(tool)"
                        [tool]="tool"></purchase-order-button>
                    </span>
                  </td>
                </ng-container>

                <tr
                  mat-header-row
                  *matHeaderRowDef="getSelectHeaderColumnsWithAction()"></tr>
                <tr
                  mat-header-row
                  *matHeaderRowDef="getDisplayedColumns(); sticky: true"></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: getDisplayedColumns()"
                  class="c-table__row"></tr>
              </table>
            </div>
          </div>
          <div class="c-pagination--desktop">
            <div class="col-12">
              <mat-paginator
                (page)="onPageChange($event)"
                [showFirstLastButtons]="true"
                [pageSize]="pageSize"
                [length]="toolsTotal"
                [pageSizeOptions]="[10, 50, 100]"></mat-paginator>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</mat-sidenav-container>
